export default __webpack_public_path__ + "static/media/cause5.77740fbd.png";